import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Button } from '@mui/material';
import PageHeader from 'shared/components/page-header/page-header';

import './dashboard.scss';

export default function Dashboard(): ReactElement {
  const { t } = useTranslation('dashboard');

  const insightPortalUrl = import.meta.env.VITE_INSIGHT_PORTAL_URL;
  const handleOpenInsights = () => {
    let fullUrl;

    if (insightPortalUrl?.startsWith('https://')) {
      fullUrl = insightPortalUrl;
    } else {
      fullUrl = `https://${insightPortalUrl}`;
    }

    window.open(fullUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="dashboard-container">
      <PageHeader title={t('pageTitle')} hideDivider />
      <div className="dashboard-child-container" data-testid="dashboardContainer">
        <Button startIcon={<OpenInNewIcon />} variant="text" onClick={handleOpenInsights} className="insight-link">
          {t('insightLinkText')}
        </Button>
        <p className="insight-info">{t('insightInfoText', { url: insightPortalUrl })}</p>
        <Outlet />
      </div>
    </div>
  );
}
